module.exports = __webpack_public_path__ + "img/bg-mbl-A.dcbbd724.png";